import { ParamMap, Router } from '@angular/router';

export function reloadCurrentRoute(router: Router): Promise<boolean> {
  const currentUrl = router.url;
  return router
    .navigateByUrl('/', { skipLocationChange: true })
    .then(() => router.navigateByUrl(currentUrl));
}

export function readParamList<T extends string>(
  params: ParamMap,
  key: string,
  isValid: (value: string) => value is T
): T[] {
  return (params.get(key) ?? '')
    .split(',')
    .map((value) => value.trim())
    .filter(isValid);
}

export function readParamText(params: ParamMap, key: string): string {
  return params.get(key)?.trim() ?? '';
}

export function writeParamList(values: readonly string[]): string | null {
  return values.length > 0 ? values.join(',') : null;
}

export function writeParamText(value: string): string | null {
  return value.trim() || null;
}

export function readParamPageIndex(params: ParamMap, key = 'page'): number {
  const value = Number(params.get(key));

  return Number.isInteger(value) && value >= 0 ? value : 0;
}

export function readParamPageSize(
  params: ParamMap,
  defaultSize: number,
  allowedSizes: readonly number[],
  key = 'pageSize'
): number {
  const value = Number(params.get(key));

  return allowedSizes.includes(value) ? value : defaultSize;
}

export function writeParamPageIndex(pageIndex: number): number | null {
  return pageIndex > 0 ? pageIndex : null;
}

export function writeParamPageSize(pageSize: number, defaultSize: number): number | null {
  return pageSize !== defaultSize ? pageSize : null;
}
